import React, { useEffect } from "react";

import { useVerifyAccount } from "./useVerifyAccount.hooks";
import { Error } from "../../_common/Error";
import { SuccessMessage } from "../../_common/SuccessMessage";
import { Spinner } from "../../_common/Spinner";

export function VerifyAccount({ match }) {
  const {
    isLoading,
    successMessage,
    error,
    handleVerification,
  } = useVerifyAccount();

  const { token } = match.params;

  useEffect(() => {
    handleVerification(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  function handleLoginClick() {
    window.location.href = "/app/login";
  }
  return (
    <div>

      {isLoading && <Spinner isLoading={isLoading} />}
      {error && <Error message={error} />}
      {successMessage && (
        <>
          <SuccessMessage message={successMessage} />
          <button
            onClick={handleLoginClick}
            className="tw-flex tw-w-full tw-rounded-md tw-bg-blue-500 tw-justify-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-xs hover:tw-bg-blue-400 focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-500"
            type="submit"
          >
            Go to Login
          </button>
        </>
      )}

    </div>
  );
}
